import { render, staticRenderFns } from "./template.vue?vue&type=template&id=4fb2f445&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&id=4fb2f445&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb2f445",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb2f445')) {
      api.createRecord('4fb2f445', component.options)
    } else {
      api.reload('4fb2f445', component.options)
    }
    module.hot.accept("./template.vue?vue&type=template&id=4fb2f445&scoped=true&", function () {
      api.rerender('4fb2f445', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/template.vue"
export default component.exports